import { getBlockDefaultClassName } from '@wordpress/blocks';
import { Fragment } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { TextControl } from '@wordpress/components';
import { InnerBlocks } from '@wordpress/block-editor';
import './style.scss';

const Tab = {
  title: __('Tab'),
  description: __('Tab to use as element in the tabs block.'),
  icon: 'category',
  parent: [ 'abs/content-tabs-block' ],
  attributes: {
    title : {
      type:   'string',
      default: 'New tab',
    },
    blockId: {
      type: 'string',
      default: '',
    }
  },
  supports: {
    customClassName: false,
  },
  edit: ({ className, attributes, setAttributes, clientId }) => {
    const { title } = attributes;
    attributes.blockId = clientId;

    return (
      <Fragment>
        <div className={ className }>
          <div className={"tab__label"}>
            <TextControl
              label={ __('Tab Label') }
              hideLabelFromVision={true}
              value={ title }
              placeholer={ __('Please enter a label') }
              onChange={(title) => setAttributes({ title })}
              type="string"
            />
          </div>
          <div className={"tab__content"}>
            <InnerBlocks />
          </div>
        </div>
      </Fragment>
    );
  },

  save: ({ attributes }) => {
    const {blockId} = attributes;
    const className = String(getBlockDefaultClassName( 'abs/content-tab-block' ));
    const classes = [className, 'tab-pane', 'fade'];
    const arialabel = blockId + '-tab';

    return (
      <div className={ classes.join(' ') } id={ `panel-${blockId}` } role="tabpanel" aria-labelledby={ arialabel }>
        <InnerBlocks.Content />
      </div>
    );
  }
};

export default Tab;
